import { autoinject } from 'aurelia-framework';
import { ErpSystem } from 'models';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class ErpSystemService extends BaseApiService<ErpSystem> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, ErpSystem);
  }
}
